import React from 'react';
import {classes, style} from './dopp-layout-separator.st.css';
import {Values} from '@wix/devzai-utils-common';


export const DoppLayoutSeparatorSkin = {
    Actions: 'actions',
    Profile: 'profile',
    ProfileNoHorizontalMargin: 'profileNoHorizontalMargin'
} as const;

export type DoppLayoutSeparatorSkin = Values<typeof DoppLayoutSeparatorSkin>;

export const DoppLayoutSeparator = React.memo(function DoppLayoutSeparator(props: DoppLayoutSeparator.Props) {
    const {
        className,
        skin,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                skin: skin
            }, className)}
        />
    )
});

export namespace DoppLayoutSeparator {

    export interface Props extends React.HTMLAttributes<any> {
        skin: DoppLayoutSeparatorSkin;
    }
}